import { render, staticRenderFns } from "./YouthPage.vue?vue&type=template&id=4c223944&"
import script from "./YouthPage.vue?vue&type=script&lang=js&"
export * from "./YouthPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports